import { z } from "zod";
import { phonePattern, passwordSchema } from "./shared";

export const registerPropertySchema = z.object({
  propertyAddress: z.string().min(5, "Address is required").max(100),
  estimatedPropertyValue: z.number().min(1),
});

export const registerUserSchema = z.object({
  firstName: z.string().min(2, "First name is required").max(50),
  lastName: z.string().min(2, "Last name is required").max(50),
  email: z.string().email("A valid email is required"),
  phone: z.string().regex(phonePattern, "A valid phone number is required"),
});

export const registerPasswordSchema = z.object({
  password: passwordSchema,
});
